import React from 'react';
import AppBarBase from '@material-ui/core/AppBar';

const AppBar = (props) => <AppBarBase {...props} />;

export default AppBar;
